export default __webpack_public_path__ + "static/media/trash_can.f47f436f.svg";